import React from "react";

const ExpiredModal = ({ open, item, onHabis, onWaste }) => {
  if (!open || !item) return null;

  return (
    <div className="modal is-active">
      <div
        className="modal-background"
        style={{
          background: "rgba(0,0,0,.75)",
        }}
      />

      <div
        className="modal-card"
        style={{
          width: "95%",
          maxWidth: "500px",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        <header
          className="modal-card-head"
          style={{
            background: "#C62828",
          }}
        >
          <p
            className="modal-card-title has-text-white"
            style={{
              fontWeight: "bold",
              fontSize: "24px",
            }}
          >
            🚨 SHELFLIFE EXPIRED
          </p>
        </header>

        <section
          className="modal-card-body"
          style={{
            textAlign: "center",
          }}
        >
          <h2
            className="title is-3"
            style={{
              marginBottom: "10px",
            }}
          >
            {item.name}
          </h2>

          <p
            style={{
              fontSize: "18px",
            }}
          >
            Produk telah melewati batas Shelflife
          </p>

          <div
            style={{
              marginTop: "20px",
              padding: "15px",
              border: "2px solid #C62828",
              borderRadius: "10px",
              background: "#FFF5F5",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "#777",
              }}
            >
              Expired Time
            </div>

            <div
              style={{
                fontSize: "32px",
                color: "#C62828",
                fontWeight: "bold",
              }}
            >
              {item.endShelflife}
            </div>
          </div>
        </section>

        <footer
          className="modal-card-foot"
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          <button className="button is-warning is-fullwidth" onClick={onHabis}>
            HABIS
          </button>

          <button className="button is-danger is-fullwidth" onClick={onWaste}>
            WASTE
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ExpiredModal;
